import * as MainActionTypes from './action-types.constants';
import * as MainActions from './main.actions';
import DFP_CONSTANTS from '@medscape-promo/medscapetv/post-messages/dfp.constants.json';

function addIFI(storeAPI, config) {
    storeAPI.dispatch(MainActions.addIFI(config));
}
const MainMiddleware = (storeAPI) => {
    return next => action => {
        // Do something in here, when each action is dispatched
        //const state = storeAPI.getState();
        //console.log('[MainRouterMiddleware] current state', state)
        //console.log('[MainRouterMiddleware] dispatching', action.type);
        //console.log("[MainRouterMiddleware] ModalActionTypes.OPEN:", ModalActionTypes.OPEN);

        let result = next(action);
        //const nextState = storeAPI.getState();
        //console.log('[MainMiddleware] next state', nextState);
        switch (action.type) {
            case  MainActionTypes.INIT:
                (() => {
                    import('@medscape-promo/medscapetv/post-messages').then(module => {
                        const { store: pmStore } = module;
                        const pmState = pmStore.getState();
                        if(pmState[DFP_CONSTANTS["IFI"]] == null) {
                            let unsubscribe = pmStore.subscribe( () => {
                                const pmState = pmStore.getState();
                                if(pmState[DFP_CONSTANTS["IFI"]] != null) {
                                    addIFI(storeAPI,pmState[DFP_CONSTANTS["IFI"]])
                                    unsubscribe();
                                }
                            })
                        }
                        else {
                            addIFI(storeAPI,pmState[DFP_CONSTANTS["IFI"]])
                        }

                    })
                })()
                break;

        }
        return result
    }

}

export default MainMiddleware;